export default [
    {
        id: 1,
        title: 'How to use the Budget Card',
        date: '2018-05-30',
        author: 'Jason Williams'        
    },
    {
        id: 2,
        title: 'Scheduling Emailing and Notifications',
        date: '2018-06-30',
        author: 'Brady Giles'
    },
    {
        id: 3,
        title: 'IBA Dashboards 2.0',
        date: '2018-07-31',
        author: 'Kirk Peterson'
    },
    {
        id: 4,
        title: 'Harnessing the Power of My Data to Drive Revenue',
        date: '2019-11-13',
        author: 'Mike Romney'
    },
    {
        id: 5,
        title: 'New Dashboard Features Added!',
        date: '2020-03-01',
        author: 'Brady Giles'
    }
]

    

    






// WEBPACK FOOTER //
// ./src/js/components/blogs/posts/posts.js